/* tslint:disable */
/* eslint-disable */
/**
 * ScriptSure Functions API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DataBaseDto } from "./data-base-dto";
import { ErrorListDto } from "./error-list-dto";
/**
 *
 * @export
 * @interface PatientLogDto
 */
export interface PatientLogDto extends DataBaseDto {
  /**
   * The patient MRN.
   * @type {string}
   * @memberof PatientLogDto
   */
  MRN: string;
  /**
   * ksuid
   * @type {string}
   * @memberof PatientLogDto
   */
  logId?: string;
  /**
   *
   * @type {string}
   * @memberof PatientLogDto
   */
  level: PatientLogDtoLevelEnum;
  /**
   * The error message or errorList summary.
   * @type {string}
   * @memberof PatientLogDto
   */
  message: string;
  /**
   *
   * @type {ErrorListDto}
   * @memberof PatientLogDto
   */
  errorList?: ErrorListDto;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientLogDtoLevelEnum {
  DEBUG = "DEBUG",
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
}



// WEBPACK FOOTER //
// ./src/models/scriptSure/patient-log-dto.ts